// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TCApiGatewayServiceClientsEnumsContactInfoPurposeType } from './tCApiGatewayServiceClientsEnumsContactInfoPurposeType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TCApiGatewayControllersAccountModelsSharedEmailAddressPatientDataModel {
    'emailAddressType'?: TCApiGatewayServiceClientsEnumsContactInfoPurposeType;
    'address'?: string | null;
    'language'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCApiGatewayControllersAccountModelsSharedEmailAddressPatientDataModel>> = [
        {
            "name":     "emailAddressType",
            "baseName": "emailAddressType",
            "type":     "TCApiGatewayServiceClientsEnumsContactInfoPurposeType"
        },
        {
            "name":     "address",
            "baseName": "address",
            "type":     "string"
        },
        {
            "name":     "language",
            "baseName": "language",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return TCApiGatewayControllersAccountModelsSharedEmailAddressPatientDataModel.attributeTypeMap;
    }
}
